﻿require("jquery");
import 'es5-shim';  //not sure this is needed, the code is from https://github.com/jerrysu/backbone-webpack-example/blob/master/js/main.js
require("backbone");
require("underscore");
require("backbone-validation");
require("croppie");
